// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"a78c7b14","160":"1e6513e7","208":"f9f30bf3","293":"8e282156","516":"dcc536f0","519":"da3f14d8","917":"56020747","946":"2646d1f5"}[chunkId] + ".chunk.js";
};